import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { header } from 'constants/table';
import { RowItemDanhSachDon } from './datatable';
import DataTable from 'components/data-table';
import { Button } from "@blueprintjs/core";
import queryString from 'query-string';
import moment from 'moment';
import { TheoDoiGiamSat } from 'api';
import { isEmpty, includes, get } from 'lodash';
import classnames from 'classnames';
import { API_URL } from 'constants/config';
import { downloadFile } from "constants/downloadFile";

export default class DanhSachDonTheoKy extends Component {
  constructor(props, context) {
    super(props, context);
    const parsed = queryString.parse(window.location.search);
    const filterTheoKyData = JSON.parse(localStorage.getItem("tdgstk"));
    this.state = {
      data: [],
      trangThaiDon: get(parsed, 'trangThaiDon', ''),
      id: get(parsed, 'donViId', ''),
      ky: get(parsed, 'ky', ''),
      chiThuocQuyenLanhDao: get(parsed, 'chiThuocQuyenLanhDao', ''),
      donChuaChuyen: parsed.isPhongBanChuaChuyenDon || '',
      tuKhoa: '',
      tiepNhanTuNgay: get(filterTheoKyData, 'tiepNhanTuNgay') ? new Date(filterTheoKyData.tiepNhanTuNgay) : '',
      tiepNhanDenNgay: get(filterTheoKyData, 'tiepNhanDenNgay') ? new Date(filterTheoKyData.tiepNhanDenNgay) : '',
      year: get(filterTheoKyData, 'year', moment().format('YYYY')),
      month: get(filterTheoKyData, 'month', ''),
      kyBaoCao: get(filterTheoKyData, 'selectedTheoKy', ''),
      loaiDonThu: get(filterTheoKyData, 'loaiDonThu', ''),
      timKiemTheo: get(filterTheoKyData, 'timKiemTheo', 'year'),
      nguonDon: get(filterTheoKyData, 'nguonDon', ''),
      tableLoading: false,
      searchLoading: false,
      search: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tenDonVi: ''
    }
  }

  componentDidMount() {
    this.getListData();
    this.getTenDonVi();
  }

  getTheoKy() {
    if (!isEmpty(this.state.ky)) {
      return this.state.ky
    }
    return this.state.kyBaoCao
  }

  getTenDonVi() {
    let params = {
      donViId: this.state.id,
      tinhTrangXuLy: 'DUNG_HAN'
    }
    TheoDoiGiamSat.actions.getTenDonViTaiDanhSachDungHanTreHan.request('',params).then(res => {
      if(res.data) {
        this.setState({
          tenDonVi: get(res, 'data.donVi.ten', '')
        });
      }
    })
  }

  async getListData(tuKhoa = '') {
    this.setState({
      tableLoading: true,
      searchLoading: true
    });
    let params = {
      phanLoaiDon: this.state.loaiDonThu || undefined,
      ky: this.getTheoKy() || undefined,
      nguonDon: this.state.nguonDon || undefined,
      trangThaiDon: !isEmpty(this.state.trangThaiDon) ? this.state.trangThaiDon.join(',') : undefined,
      donViId: this.state.id || undefined,
      chiThuocQuyenLanhDao: this.state.chiThuocQuyenLanhDao || undefined,
      isPhongBanChuaChuyenDon: this.state.donChuaChuyen === "true" ? true : undefined,
      page: this.state.pageData.number,
      size: this.state.pageData.size
    }
    if (this.state.timKiemTheo === 'day') {
      params.tuNgay = this.state.tiepNhanTuNgay ? moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString() : undefined;
      params.denNgay = this.state.tiepNhanDenNgay ?  moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString() : undefined;
    }
    if (this.state.timKiemTheo === 'month') {
      params.month = this.state.month;
      params.year = this.state.year;
    }
    if (this.state.timKiemTheo === 'year') {
      params.year = this.state.year;
    }
    if (!isEmpty(tuKhoa)) {
      params.tuKhoa = tuKhoa
    }
    if (this.state.chiThuocQuyenLanhDao) {
      params = {
        trangThaiDon: !isEmpty(this.state.trangThaiDon) ? this.state.trangThaiDon.join(',') : undefined,
        donViId: this.state.id || undefined,
        chiThuocQuyenLanhDao: this.state.chiThuocQuyenLanhDao || undefined,
        year: moment().format('YYYY'),
        ky: this.getTheoKy() || undefined,
        page: this.state.pageData.number,
        size: this.state.pageData.size
      }
    }
    await TheoDoiGiamSat.actions.getDanhSachDonTaiDonVi.request('',params).then(res => {
      this.setState({
        data: !isEmpty(res.data._embedded) ? res.data._embedded.dons : [],
        pageData: res.data.page,
      });
    }).catch(error => {
      console.error("Error :" + error);
      this.setState({
        tableLoading: false,
        searchLoading: false
      })
    }).finally(() => {
      this.setState({
        tableLoading: false,
        searchLoading: false
      })
    })
  }

  handleSearch() {
    this.getListData(this.state.tuKhoa);
  }

  onChange(e) {
    const { value } = e.target
    this.setState({
      tuKhoa: value
    })
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getListData();
    })
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: 0,
        size: size
      }
    }, () => {
      this.getListData();
    })
  }

  handleExportExcel() {
    this.setState({
      loadingExport: true
    });
    try {
      let URL = String(API_URL) + "/theoDoiGiamSatTheoKys/danhSachDonTaiDonVi/xuatExcel?"
      + "donViId=" + this.state.id
      if (!isEmpty(this.state.tuKhoa)) {
        URL = URL + "&tuKhoa=" + this.state.tuKhoa;
      }
      if (this.state.loaiDonThu) {
        URL = URL + "&phanLoaiDon=" + this.state.loaiDonThu;
      }
      if (!isEmpty(this.state.ky) || !isEmpty(this.state.kyBaoCao)) {
        URL = URL + "&ky=" + this.getTheoKy();
      }
      if (!isEmpty(this.state.trangThaiDon)) {
        URL = URL + "&trangThaiDon=" + this.state.trangThaiDon.join(',');
      }
      if (this.state.chiThuocQuyenLanhDao) {
        URL = URL + "&year=" + moment().format('YYYY');
        URL = URL + "&chiThuocQuyenLanhDao=" + this.state.chiThuocQuyenLanhDao;
      } else {
        if (this.state.timKiemTheo === 'day') {
          if (get(this.state, 'tiepNhanTuNgay')) {
            URL = URL + "&tuNgay=" + moment(this.state.tiepNhanTuNgay).add(7,'hours').toISOString();
          }
          if (get(this.state.filterTheoKy, 'tiepNhanDenNgay')) {
            URL = URL + "&denNgay=" + moment(this.state.tiepNhanDenNgay).add(7,'hours').toISOString();
          }
        }
        if (this.state.timKiemTheo === 'month') {
          URL = URL + "&month=" + this.state.month;
          URL = URL + "&year=" + this.state.year;
        }
        if (this.state.timKiemTheo === 'year') {
          URL = URL + "&year=" + this.state.year;
        }
        if (this.state.donChuaChuyen) {
          URL = URL + "&isPhongBanChuaChuyenDon=" + this.state.donChuaChuyen;
        }
      }
      downloadFile(URL);
    } catch (error) {

    } finally {
      setTimeout(function () {
        this.setState({
          loadingExport: false
        });
      }.bind(this), 3000);
    }
  }

  render() {
    const getTitle = () => {
      let title = 'Danh sách đơn thuộc thẩm quyền lãnh đạo đơn vị';
      if (this.state.chiThuocQuyenLanhDao && includes(this.state.trangThaiDon, 'DA_XU_LY')) {
        title = 'Danh sách đơn đã xử lý, giải quyết thuộc thẩm quyền lãnh đạo đơn vị';
      }
      if (this.state.chiThuocQuyenLanhDao && includes(this.state.trangThaiDon, 'DANG_XU_LY')) {
        title = 'Danh sách đơn đang xử lý, giải quyết thuộc thẩm quyền lãnh đạo đơn vị';
      }
      return title;
    }
    return (
      <div className="center reception-container">
        <div className="back-foward mb0">
          <Link onClick={browserHistory.goBack} title="">Về trang trước</Link>
        </div>
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-theo-doi"></i>
              { this.state.chiThuocQuyenLanhDao ? getTitle() : 'Danh sách theo dõi đôn đốc theo kỳ'}
            </p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <div className='row pl10 pr10 pb20 theo-doi'>
              <section className="wrap-block search-container col-80">
                <form className="search-form" action="javascript:void(0)" onSubmit={this.handleSearch.bind(this)}>
                  <input
                    type="text"
                    placeholder="Nhập tên người đứng đơn hoặc số CMND để tìm kiếm..."
                    className="search-input"
                    value={this.state.tuKhoa}
                    onChange={this.onChange.bind(this)}
                  />
                  <Button
                    type="submit"
                    text="Tìm kiếm"
                    className={this.state.tableLoading ? (this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
                    />
                </form>
              </section>
              <div className="col-20 text-right">
                <Link
                  className={classnames('btn-green tt-export', {'btn-loading-inline': this.state.loadingExport})}
                  onClick={this.handleExportExcel.bind(this)}
                >
                  Xuất danh sách
                </Link>
              </div>
            </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={header.theoDoi.danhSachDonTreHan}
            dataList={this.state.data}
            pageData={this.state.pageData}
            parent={this}
            hideButtonExport
            search={this.state.search}
            tableLoading={this.state.tableLoading}
          >
            <RowItemDanhSachDon tenDonVi={this.state.tenDonVi}/>
          </DataTable>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/DanhSachDonTheoKy.jsx